/**
 * Changes the https/http protocol from a URL to wss/ws
 * @param {string} url URL to apply the change
 * @returns {string} URL string with wss/ws protocol
 */
export var fromHttpToWebsocketURL = function (url) { return url.replace(/^http/, 'ws'); };
